export class ObjectUtils {
    
    public static isDefined(obj, path) {
        if (obj == null) { return false; }
        const parts = path.split('.');
        let result = obj;
        for (let i = 0; i < parts.length; i++) {
            result = result[parts[i]];
            if (result == null) {
                return false;
            }
            else if (typeof result == 'undefined') {
                return false;
            }
        }
        return true;
    }

    public static getNestedValue(obj, propertyString) {
        const result = propertyString.split('.').reduce((o, p) => o && o[p], obj || '');
        return result !== undefined ? result : (result === 0 ? 0 : '');
    }
}